import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { notification } from 'antd'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditTemplatePayload } from '@app-store/slices/templates/edit'

interface TaskAction extends Action {
    payload: IEditTemplatePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.templates.edit

function* editTemplateSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/notifications/templates/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
            notification.success({
                message: 'Template updated successfully.'
            })
        } else {
            yield payload.sagaCB?.onError()
            throw new Error('')
        }
    } catch (error) {
        yield payload.sagaCB?.onError()
        yield put(onFailure(error))
    }
}

function* editTemplateSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editTemplateSagaTask)
}

export default editTemplateSaga
